import { ErrorBase } from './error-base';

type InternalServerErrorData = {
  actionProps?: {
    to: string;
    label: string;
  };
};

export class InternalServerError extends ErrorBase<InternalServerErrorData> {
  constructor(data?: InternalServerErrorData) {
    super(500, 'Internal Server Error', data ?? {});
  }
}
